import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {API_URL} from "../../App";


const getRankStyle = (bot) => {
  switch (bot?.metrics?.rank) {
    case 1:
      return "text-xl font-bold text-yellow-500"; // Gold
    case 2:
      return "text-xl font-bold text-gray-300"; // Silver
    case 3:
      return "text-xl font-bold text-yellow-700"; // Bronze
    default:
      return "text-md font-medium text-white"; // Default rank color
  }
};

const getRankText = (bot) => {
  if (bot?.is_out) {
    return "Out!";
  } else if (bot?.metrics?.rank === 0) {
    return "#???";
  } else {
    return `#${bot.metrics.rank}`;
  }
};

// Function to determine background color
const getBotBgClass = (bot) => {
  if (bot?.is_out) {
    return "bg-red-900/50 hover:bg-red-800/50"; // Dark red for eliminated bots
  } else if (bot?.metrics?.rank === 0) {
    return "bg-blue-900/50 hover:bg-blue-800/50"; // Dark blue for uninitialized bots
  }
  return "bg-gray-800/70 hover:bg-gray-700/70"; // Default background
};

const UserProfile = () => {
  const [bots, setBots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { twitchDisplayName } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBots = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/bots/${twitchDisplayName}`);
        setBots(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBots();
  }, [twitchDisplayName]);

  if (loading) return <p className="text-gray-400 text-sm">Loading bots...</p>;
  if (error) return <p className="text-red-500 text-sm">Error: {error}</p>;

  return (
    <div className="max-w-sm mx-auto p-6">
      <h2 className="text-lg font-semibold border-b border-gray-700 pb-2 mb-4">
        {twitchDisplayName}'s Bots
      </h2>

      {bots.length === 0 ? (
        <p className="text-gray-400 text-sm">No bots created yet.</p>
      ) : (
        <div className="space-y-2">
          {bots.map((bot) => (
            <div
              key={bot.tag}
              className={`max-w-sm py-0.5 rounded-lg cursor-pointer px-3 flex items-center justify-between ${getBotBgClass(bot)}`}
              onClick={() => navigate(`${bot.tag}`)}
            >
              {/* Rank Column */}
              <span className={`${getRankStyle(bot)} w-12 text-center`}>
                {getRankText(bot)}
              </span>

              {/* Character Icon Column */}
              <img
                src={`/icons/${bot.character}_${bot.costume_id}.png`}
                alt=""
                className="w-8 h-8 rounded-md"
              />

              {/* Bot Name Column */}
              <span className="text-md font-semibold truncate w-32 text-center">
                {bot.tag}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UserProfile;
